import React from "react";
import styled from "styled-components";
import { useNoticeListQuery } from "@hook/csboard/useNoticeListQuery";
import { useRouter } from "next/router";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import { connect } from "react-redux";
import "swiper/css";
import "swiper/css/pagination";

SwiperCore.use([Pagination]);

const NoticeESG = ({ dummyList }) => {
  const router = useRouter();
  const { data: noticeList = [] } = useNoticeListQuery();

  const defaultImage = "/img/esg_default_img.png";

  const processed =
    dummyList?.esg?.map((item) => {
      const match = item.contents.match(/<img[^>]+src="([^"]+)"[^>]*>/);
      return {
        ...item,
        imageUrl: match ? match[1] : defaultImage,
      };
    }) || [];

  return (
    <NoticeESGWrapper>
      <NoticeSection>
        <SectionHeader>
          <h4>공지사항</h4>
          <span
            className="more-text hover-up"
            onClick={() => router.push("/csboard/notice/")}
          >
            <li>{"전체보기"}</li>
            <StyledMoreButton>
              <i className="fi-rs-plus-small" />
            </StyledMoreButton>
          </span>
        </SectionHeader>

        <NoticeList>
          {noticeList.map((item, index) => (
            <NoticeItem
              key={index}
              onClick={() => router.push(`/csboard/notice/${item.id}/`)}
            >
              <span>{item.title}</span>
              <span>{item.wdate}</span>
            </NoticeItem>
          ))}
        </NoticeList>
      </NoticeSection>

      <ESGSection>
        <SectionHeader>
          <h4>ESG자료실</h4>
          <span
            className="more-text hover-up"
            onClick={() => router.push("/esg-guide/news/")}
          >
            <li>전체보기</li>
            <StyledMoreButton>
              <i className="fi-rs-plus-small" />
            </StyledMoreButton>
          </span>
        </SectionHeader>

        {/* ✅ PC용 ESG */}
        <div className="pc_esg">
          <ESGList>
            {processed.map((item) => {
              const isDefault = item.imageUrl === defaultImage;
              return (
                <ESGItem
                  key={item.id}
                  isDefault={isDefault}
                  onClick={() => router.push(`/esg-guide/post/${item.id}/`)}
                >
                  <div className="image-area">
                    <img src={item.imageUrl} alt={item.title} />
                    {isDefault && item.summary && (
                      <p className="summary-overlay">{item.summary}</p>
                    )}
                  </div>
                  <p className="title">{item.title}</p>
                </ESGItem>
              );
            })}
          </ESGList>
        </div>

        {/* ✅ 모바일용 ESG Swiper */}
        <div className="m_esg">
          <Swiper
            spaceBetween={10}
            pagination={{ type: "fraction" }}
            loop={true}
            loopAdditionalSlides={1}
          >
            {processed.map((item) => {
              const isDefault = item.imageUrl === defaultImage;
              return (
                <SwiperSlide key={item.id}>
                  <ESGItem
                    isDefault={isDefault}
                    onClick={() => router.push(`/esg-guide/post/${item.id}/`)}
                  >
                    <div className="image-area">
                      <img src={item.imageUrl} alt={item.title} />
                      {isDefault && item.summary && (
                        <p className="summary-overlay">{item.summary}</p>
                      )}
                    </div>
                    <p className="title">{item.title}</p>
                  </ESGItem>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </ESGSection>
    </NoticeESGWrapper>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

export default connect(mapStateToProps)(NoticeESG);

// --------------------- styled-components ---------------------

const NoticeESGWrapper = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;
  justify-content: space-between;
  padding: 30px 0;

  @media screen and (max-width: 991px) and (min-width: 768px) {
    flex-direction: column;
    gap: 50px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 50px;
  }
`;

const NoticeSection = styled.div`
  flex: 1;
`;

const ESGSection = styled.div`
  flex: 1;

  .pc_esg {
    display: block;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .m_esg {
    display: none;

    @media (max-width: 768px) {
      display: block;
    }

    .swiper {
      padding-bottom: 20px;
    }
  }

  .swiper-pagination-fraction {
    background-color: #000;
    width: fit-content;
    padding: 0px 10px;
    border-radius: 20px;
    left: auto;
    right: 15px;
    bottom: 65px;
    color: #fff;
    font-size: calc(10px + (14 - 10) * ((100vw - 320px) / (1920 - 320)));
  }
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 26px;
  margin-bottom: 16px;

  .more-text {
    font-size: 14px;
    font-weight: normal;
    color: #888;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }
`;

const StyledMoreButton = styled.span`
  background-color: #9f9f9f;
  border-radius: 999px;
  padding: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  cursor: pointer;

  i {
    font-size: 16px;
    color: #fff;
    line-height: 1;
  }
`;

const NoticeList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
`;

const NoticeItem = styled.li`
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover span:first-child {
    color: #3bb77e;
  }

  span:last-child {
    color: #aaa;
    font-size: 13px;
  }
`;

const ESGList = styled.div`
  display: flex;
  gap: 7%;

  @media screen and (max-width: 991px) and (min-width: 768px) {
    justify-content: center;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const ESGItem = styled.div`
  position: relative;
  width: 250px;
  height: 250px;

  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .image-area {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
    background: #f9f9f9;
    border-radius: 12px;
    cursor: pointer;
  }

  .summary-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #666;
    line-height: 1.4;
    padding: 0 20px;
    text-align: start;
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: 90%;
    pointer-events: none;
  }

  .title {
    font-size: 16px;
    color: #333;
    margin-top: auto;
    padding: 0 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  &:hover .title {
    color: #3bb77e;
    cursor: pointer;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;

    .title {
      font-size: 15px;
      padding: 8px 0;
    }

    .summary-overlay {
      -webkit-line-clamp: 5;
    }
  }
`;
